const pl = {
	back: "Wstecz",
	returnLetter: "Wróć do listy pism",
	returnTemplate: "Wróć do listy szablonów",
	download: "Pobierz",
	downloadOriginal: "Pobierz",
	downloadWorkingText: "Pobierz",
	cancel: 'Anuluj',
	clear: 'Wyczyść',
	load: 'Załaduj',
	add: "Dodaj",
	delete: "Usuń",
	import: 'Importuj',
	close: "Zamknij",
	fieldRequired: '! To pole nie może pozostać puste',
	save: 'Zapisz',
	saveChanges: 'Zapisz zmiany',
	required: "* Pola wymagane",
	roles: {
		editor: "Redaktor",
		admin: "Administrator",
		reader: "Czytelnik",
		expert: "Ekspert",
	},
	file: {
		name: "Dodany plik:",
		errors: {
			format: "Zły format pliku.",
			files: "Zbyt wiele plików. Proszę wybrać jeden plik.",
		},
	},
	header: {
		logoAlt: "Logo Bazy Tekstów Urzędowych",
		menu: {
			letters: "Pisma",
			templates: "Szablony",
			addLetter: "Dodaj pismo",
			userWelcome: 'Witaj,',
			infoDownload: 'Pobierz instrukcję obsługi serwisu',
			simpleText: "Uprość z AI",
			simpleTextLinks: {
				mainLabel: "Prosty Język w pismach urzędowych",
			},
			howToUseService: {
				mainLabel: "Jak korzystać z serwisu?",
				options: {
					tDownloadInstruction: "Pobierz instrukcję obsługi (PDF)",
					tShowOnboarding: "Pokaż wprowadzenie do narzędzia",
				},
			},
			simpleTextAdvices: {
				mainLabel: "Poradnia Prostego Języka",
				options: {
					tFindAdvice: "Znajdź poradę",
					tMyQuestions: "Moje pytania",
					tAskQuestion: "Zadaj pytanie",
					tAdmin: "Zarządzaj pytaniami",
				},
			},
			logout: "Wyloguj się",
			dict: "Słownik",
			myAccount: {
				mainLabel: "Moje konto",
				options: {
					tUserList: "Użytkownicy",
					tDepartmentList: "Wydziały",
					tReport: "Raport o danych osobowych",
					tTemplateManagement: "Zarządzanie szablonami",
					tChangePassword: "Zmień hasło",
					tLogout: "Wyloguj się",
				},
			},
		},
	},
	templates: {
		searchLabel: "Wyszukaj szablon po nazwie lub treści",
		title: "Szablony",
		howToCreateTemplate: "Jak utworzyć szablon?",
		howToCreateTemplateTooltip: "W tym celu przejdź do pism. Szablony tworzy się tylko na podstawie pism, które są na <strong>zakończonym etapie upraszczania.</strong>",
		description: "Szablony pokazują jak zachować właściwą strukturę pisma i przekazać niezbędną ilość informacji, w prostej formie. Użyj ich jako wzorów do sporządzenia nowego pisma w powiązanej sprawie lub kategorii.",
		templateName: 'Nazwa szablonu',
		useTemplateButton: 'Użyj szablonu',
		noElements: 'Brak szablonów spełniających określone kryteria wyszukiwania.',
		createLetterUponTemplate: 'Pobierz pismo na podstawie szablonu (*.docx)',
		defaultDeptTooltip: 'Domyślnie wyświetlane są szablony pochodzące z wydziału, do którego należysz.',
		card: {
			department: "Wydział",
			category: "Kategoria",
			basedOn: "Na podstawie pisma",
			author: "Wprowadzający",
			createdOn: "Data dodania",
			updatedOn: "Data edycji",
			useTemplate: "Użyj szablonu",
		},
		create: {
			createTemplateHeader: 'Tworzenie szablonu',
			updateTemplateHeader: 'Edycja szablonu',
			letterLookup: 'Podgląd pisma',
			warn1: 'Pamiętaj: ',
			warn2: ' w systemie obowiązuje zakaz umieszczania danych osobowych. Wszystkie dane osobowe powinny zostać przez Ciebie zanonimizowane.',
			warnUpdated: {
				part1: 'Uwaga: ',
				part2: ' to jest nieaktualna wersja, gdyż wznowiono upraszacznie pisma, na podstawie którego powstał ten szablon.',
			},
			category: 'Kategoria *',
			categoryCom: 'Wybierz kategorię dla tworzonego szablonu',
			templateName: 'Nazwa szablonu *',
			templateNameCom: 'Podaj tytuł szablonu, np. Pozwolenie na budowę',
			usingTemplate: 'Używasz szablonu',
			creatingTemplateBasedOn: 'Tworzysz szablon na podstawie pisma',
			baseForCategory: 'Utwórz wzorzec dla kategorii',
			generalInformations: 'Informacje ogólne',
			generalInformationsDescription: 'Uzupełnij nazwę szablonu. Kategoria została skopiowana z pisma wzorcowego - zmień ją jeżeli uważasz, że to konieczne',
			requiredFields: '* Pola wymagane',
			department: 'Wydział *',
			departmentCom: 'Określ do jakiego wydziału należy szablon',
			footer: 'Wydział dla stopki',
			header: 'Wydział dla nagłówka',
			metricHeader: 'Metryka pisma',
			metricDescription: 'Wybierz jakie dane powinny zostać uzupełnione przez osobę korzystającą z szablonu',
			letterContentHeader: 'Zawartość szablonu pisma',
			letterTitleLabel: 'Tytuł szablonu pisma',
			letterContentLabel: 'Treść szablonu pisma',
			letterContentLabelDescription: 'Tutaj jest skopiowana treść pisma wzorcowego. Zredaguj ją do takiej postaci, aby mogła stanowić szablon. Nie cytuj tutaj podstawy prawnej. Podaj ją w oknie poniżej: „Podstawa prawna”. Zapoznaj się z innymi wskazówkami:',
			letterContentLabelDescriptionLink: 'Jak tworzyć proste teksty urzędowe?',
			regulationsLabel: 'Podstawa prawna',
			regulationsLabelDescription: 'Do podstawy prawnej zostały skopiowane przypisy, jeśli istnieją w piśmie wzorcowym.',
			letterContentTitle: 'Zawartość szablonu pisma',
			createTemplate: 'Utwórz szablon',
			editTemplateSubmitButton: 'Wprowadź zmiany',
			headerAndFooterSameAsLetter: 'Zastosuj nagłówek i stopkę zgodne z wybranym wydziałem',
			showMetadata: 'Pokaż metadane pisma',
			updateNotNeeded: 'Szablon nie wymaga więcej aktualizacji',
			editTemplate: 'Edytuj szablon',
		},
		info: {
			owner: 'Autor szablonu:',
		},
		use: {
			mobileHeader: 'Metadane szablonu',
			warn1: 'Wyjątkowo: ',
			warn2: 'korzystając z szablonu pisma możesz wypełnić go rzeczywistymi danymi. Wpisane dane nie będą przechowywane w systemie.',
			dept: 'Wydział',
			category: 'Kategoria',
			basedOn: 'Na podstawie pisma',
			see: 'Zobacz',
			author: 'Wprowadzający',
			addedOn: 'Data dodania',
			modifiedOn: 'Data edycji',
			hideMetadata: 'Ukryj metadane szablonu',
			showMetadata: 'Pokaż metadane szablonu',
			fillNeededDataComment: 'Uzupełnij brakujące dane, jeżeli pismo tego wymaga. Kieruj się przy tym wskazówkami: ',
			fillNeededDataLink: 'Jak tworzyć proste teksty urzędowe?',
			metricDescription: 'Uzupełnij metrykę  - tutaj lub po pobraniu pisma. Wpisane dane nie będą przechowywane w systemie - posłużą wyłącznie do wygenerowania dokumentu.',
			noMetricsDescription: 'Ten szablon nie zawiera żadnych metryk. Można je dodać podczas edycji szablonu.',
			downloadInfo: {
				part1: 'Pismo po pobraniu będzie zapisane w rekomendowanym rodzaju czcionki: ',
				part2: ', o wielkości: ',
				part3: ' px dla tytułu, ',
				part4: ' px dla nagłówków i treści, ',
				part5: ' px dla informacji w metryce. Może być dodatkowo uzupełnione o grafiki dla nagłówka i stopki charakterystyczne dla danego wydziału.',
			},
			dontQuote: 'Nie cytuj tutaj podstawy prawnej. Wyjaśnij ją w oknie poniżej: „Podstawa prawna”. ',
		},
	},
	dictionary: {
		dictionary: "Słownik",
		description: "Znajdziesz tutaj użyte w pismach urzędowych słowa i frazy oraz ich uproszczenia, przygotowane przez ekspertów językowych. Możesz się także zapoznać z ich formą podstawową (jeżeli już w niej nie występują). ",
		descriptionAdmin: "Zarządzaj słownikiem w zakresie: dodawania nowych fraz i słów, pobierania słownika lub jego usuwania.  Możesz także zbiorowo edytować słownik pobierając jego plik, edytując go lokalnie i ponownie go dodając.",
		addToDict: "Dodaj uproszczenie",
		loadDict: "Załaduj plik z uproszczeniami (.xlsx)",
		inputPhrase: "Oryginalne słowo/fraza",
		outputPhrase: "Uproszczenie",
		basicInputPhrase: "Forma podstawowa",
		basicOutputPhrase: "Uproszczenie podstawowe",
		comments: "Komentarz",
		count: "Liczba dodań",
		countTooltip: "<strong>Liczba dodań</strong> to liczba ekspertów, którzy dodali do słownika dokładnie takie samo uproszczenie.",
		download: "Pobierz słownik (.xlsx)",
		sortBy: "Sortuj według:",
		sortType: "Sposób sortowania",
		deleteDict: "Usuń słownik",
		list: {
			searchLabel: 'Wyszukaj słowa/frazy',
			options: {
				all: 'Wszędzie',
				onlyOriginal: 'Tylko oryginalne',
				onlySimplified: 'Tylko uproszczenia',
			},
			manage: "Zarządzaj",
			edit: "Edytuj",
			editMetadata: "Edytuj metadane",
			delete: "Usuń",
			noElementsAded: "Jeszcze nic nie dodano do słownika. Załaduj plik (.xlsx) lub dodaj uproszczenie",
			noElements: "Nie znaleźliśmy takiego słowa/frazy w słowniku.",
			header: {
				manage: "Zarządzaj",
				edit: "Edytuj",
				delete: "Usuń",
			},
			searchInInputPhrase: "tylko oryginalne",
			searchInOutputPhrase: "tylko uproszczenia",
		},
		modal: {
			addToDict: "Dodaj uproszczenie do słownika",
			editForm: "Edytuj uproszczenie",
			deleteElement: "Usuń hasło",
			deleteComment: "Czy na pewno chcesz usunąć hasło ?? ze słownika?",
			delete: "Usuń",
			actualize: "Aktualizuj",
		},
		modalLoad: {
			title: "Załaduj plik z uproszczeniami (.xlsx)",
			desc:{
				part1: "Załaduj plik słownika w formacie .xlsx. Plik powinien zawierać 5 kolumn o takich samych nazwach jak w tabeli na stronie:", 
				part2: {
					element1: 'Oryginalne słowo/fraza',
					element2: 'Uproszczenie',
					element3: 'Forma podstawowa',
					element4: 'Uproszczenie podstawowe',
					element5: 'Komentarz',
				},
				part3: 'Obowiązkowo wypełnij 1 i 2 kolumnę („Oryginalne słowo/fraza”, „Uproszczenie”). Pozostałe informacje są opcjonalne.',
			},
			info: "Załaduj plik (.xlsx)",
			errors: {
				headers: 'Nagłówek zawiera błędy. Popraw i spróbuj ponownie.',
				rows: 'Plik został załadowany. Wystąpił jednak błąd w wierszach nr:',
				format: "Niepoprawny format pliku. Format musi być .xlsx.",
				files: "Zbyt wiele plików. Proszę wybrać jeden plik.",
			},
			error: {
				part1: 'Wystąpił błąd! ',
				part2: 'Sprawdź czy: ',
				part3: {
					element1: 'Dodano plik w prawidłowym formacie (.xlsx.);',
					element2: 'Nie brakuje obowiązkowych kolumn; ',
					element3: 'Obowiązkowe kolumny są wypełnione. ',
				},
			},
			warning: {
				part1: 'Uwaga: ',
				part2: 'po załadowaniu pliku istniejące dane zostaną nadpisane. Jeżeli nie chcesz ich utracić - pobierz wcześniej plik słownika.',
			},
			confirm: 'Załaduj plik',
			addedFile: "Dodany plik:",
			loadAnotherFile: "To nie ten plik? Załaduj inny:",
		},
		modalDelete: {
			confirm: "Usuń słownik",
			title: "Usuń cały słownik",
			description: "Czy na pewno chcesz usunąć cały zamieszczony obecnie słownik?",
			description2: "Nie ma możliwości przywrócenia utraconych danych.",
		},
	},
	departments: {
		departments: "Wydziały",
		description1: "Zarządzaj wydziałami, do których redaktorzy mogą przypisać pisma i szablony. Po ich dodaniu możesz wprowadzić charakterystyczne grafiki dla nagłówków i stopek wprowadzonych wydziałów, przechodząc do edycji.",
		description2: "Przechodząc do edycji możesz wprowadzić charakterystyczne grafiki lub poprawić dane adresowe dla nagłówków i stopek wprowadzonych wydziałów.",
		sortBy: "Sortuj według",
		search: "Wyszukaj",
		default: "Domyślny",
		custom: "Własny",
		defaultFooter: "Domyślna",
		customFooter: "Własna",
		fieldRequired: "Pole jest wymagane",
		list: {
			name: "Nazwa wydziału",
			header: "Nagłówek",
			footer: "Stopka",
			noElements: 'Brak wydziałów spełniających określone kryteria wyszukiwania.',
			searchLabel: "Wyszukaj wydział po jego nazwie",
			editHeader: "Edytuj nagłówek",
			editFooter: "Edytuj stopkę",
			delete: "Usuń",
			deleteTooltip:  "Niektórych wydziałów nie można usunąć, ponieważ mają powiązania w systemie.",
			edit: "Edytuj nazwę wydziału",
		},
		buttons: {
			loadFile: "Załaduj plik z listą wydziałów (.xlsx)",
			addDep: "Dodaj wydział",
		},
		modalDelete: {
			title: "Usuń wydział",
			desc1: "Czy jesteś pewien, że chcesz usunąć",
			desc2: "Wydział nie ma żadnych powiązań w systemie.",
		},
		modalUpload: {
			title: "Załaduj plik z listą wydziałów (.xlsx)",
			danger: "Uwaga!",
			desc: {
				part1: 'Załaduj plik z listą wydziałów w formacie .xlsx. Plik powinien zawierać 3 kolumny, o takich samych nazwach jak w tabeli na stronie:',
				list: {
					part1: 'Nazwa wydziału',
					part2: 'Treść nagłówka',
					part3: 'Treść stopki',
				},
				part3: 'Obowiązkowo uzupełnij pierwszą kolumnę „Nazwa wydziału”, pozostałe są opcjonalne. Charakterystyczne grafiki dla nagłówków i stopek wydziałów (o ile istnieją) dodasz po załadowaniu pliku do systemu, przechodząc do edycji nagłówka i stopki.',
			},
			error: {
				part1: 'Wystąpił błąd! ',
				part2: 'Sprawdź czy: ',
				part3: {
					element1: 'Dodano plik w prawidłowym formacie (.xlsx.);',
					element2: 'Nie brakuje obowiązkowych kolumn; ',
					element3: 'Obowiązkowe kolumny są wypełnione. ',
				},
			},
			//desc: "Kolumna „Nazwa wydziału” jest obowiązkowa i musi zawierać się w przesłanym pliku. Możesz też zamieścić „Treść nagłówka” oraz „Treść stopki”.",
			info: "Załaduj plik (.xlsx)",
			dragFiles: "lub przeciągnij plik tutaj",
			browse: "Wybierz",
			addedFile: "Dodany plik:",
			loadAnotherFile: "To nie ten plik? Załaduj inny:",
			warning: {
				part1: "Uwaga:",
				part2: "jeśli są już wprowadzone dane wydziałów, to nie zostaną one nadpisane po załadowaniu tego pliku. Można je usunąć / edytować bezpośrednio w serwisie. ",
			},
		},
		modalAdd: {
			title: "Dodaj wydział",
			desc: "Po dodaniu wydziału będzie możliwe dodanie grafiki do nagłówka i stopki (jeśli istnieje).",
			required: "* Pola wymagane",
			label: "Nazwa wydziału *",
			placeholder: "Wpisz nazwę wydziału",
			warning: {
				part1: "Uwaga:",
				part2: "jeśli zmieniasz nazwę wydziału pamiętaj, aby ją uwzględnić również w tekście nagłówka i stopki.",
			},
			saveChangesButton: "Zapisz zmiany",
			addButton: "Dodaj wydział",
		},
		modalEdit: {
			title: "Edytuj nazwę wydziału",
			desc: "Zmieniasz nazwę dla",
			notUnique: "Wydział o podanej nazwie już istnieje.",
		},
		modalEditHeaderFooter: {
			titleHeader: "Edytuj nagłówek",
			descHeader: "Edytujesz nagłówek dla",
			descHeaderPart2: "Treść nagłówka i grafika będą wygenerowane w pobranych pismach pochodzących z tego wydziału i szablonach utworzonych na jego podstawie.",
			labelHeader: "Treść nagłówka",
			titleFooter: "Edytuj stopkę",
			descFooter: "Edytujesz stopkę dla",
			descFooterPart2: "Treść stopki i grafika będą wygenerowane w pobranych pismach pochodzących z tego wydziału i szablonach utworzonych na jego podstawie.",
			labelFooter: "Treść stopki",
			info: "Grafika (.jpg, .png, .bmp)",
			tImageOld: "Aktualna grafika",
			tNewImage: "Nowa grafika",
			tNoImage: "Bez grafiki",
			dragFiles: "lub przeciągnij plik tutaj",
			browse: "Wybierz",
			fieldRequired: "Pole jest wymagane",
			errors: {
				format: "Niepoprawny format. Akceptowany format to .jpg, .png, .bmp",
				files: "Zbyt wiele plików. Proszę wybrać jeden plik.",
			},
		},
	},
	users: {
		users: "Użytkownicy",
		description: "Zarządzaj użytkownikami w zakresie dodawania nowych kont, edytowania danych (poza kontami MIM) i usuwania użytkowników, którzy nie są autorami treści w systemie.",
		descriptionNoMim: "Zarządzaj użytkownikami w zakresie dodawania nowych kont, edytowania danych i usuwania użytkowników, którzy nie są autorami treści w systemie.",
		search: "Wyszukaj",
		roles: {
			all: "Wszystkie role",
			reader: "Czytelnik",
			editor: "Redaktor",
			expert: "Ekspert",
			admin: "Administrator",
		},
		accountTypes: {
			all: "Wszystkie rodzaje",
			local: "Konto lokalne",
			mim: "Konto MIM",
		},
		validation: {
			fieldRequired: "Pole jest wymagane",
			email: "Pole email jest niepoprawne",
		},
		buttons: {
			loadFile: "Załaduj plik z listą użytkowników (.xlsx)",
			addUser: "Dodaj użytkownika",
		},
		list: {
			name: "Imię i Nazwisko",
			email: "E-mail",
			department: "Wydział",
			role: "Rola",
			account: "Rodzaj konta",
			noElements: 'Brak użytkowników spełniających określone kryteria wyszukiwania.',
			searchLabel: "Wyszukaj użytkownika po imieniu lub nazwisku",
			mimAccount: "Konto MIM",
			localAccount: "Konto lokalne",
			manage: "Zarządzaj",
			edit: "Edytuj dane",
			delete: "Usuń użytkownika",
			editTooltip: "Nie ma możliwości edytowania danych użytkowników z kontem MIM.",
			deleteTooltip: "Niektórych użytkowników nie można usunąć, ponieważ są autorami treści w systemie.",
		},
		modalAdd: {
			title: "Dodaj użytkownika",
			desc: "Po dodaniu użytkownika możesz edytować wszystkie poniższe dane.",
			name: "Imię *",
			placeholderName: "Wpisz imię",
			surname: "Nazwisko *",
			placeholderSurname: "Wpisz nazwisko",
			email: "E-mail *",
			placeholderEmail: "Wpisz e-mail",
			role: "Rola *",
			placeholderRole: "Wybierz rolę",
			emailInfo: "Adres mailowy jest wymagany do komunikacji i będzie docelowo loginem użytkownika w systemie",
			departmentInfo: "Pierwszy wybrany wydział będzie widoczny na liście i po nim będzie możliwość filtrowania",
			removeDepartmentInfo: "Usuń",
			addNewDepartmentInfo: "Dodaj kolejny wydział",
			departmentLabel: "Wydział",
			departmentPlaceholder: "Wybierz wydział",
			editSaveBtn: "Zapisz zmiany",
		},
		modalEdit: {
			title: "Edytuj dane użytkownika",
			desc: "Edytujesz dane użytkownika ",
		},
		modalDelete: {
			title: "Usuń użytkownika",
			delete: "Usuń użytkownika",
			desc1: "Czy jesteś pewien, że chcesz usunąć użytkownika",
			desc2: "Użytkownik nie jest autorem żadnych treści w systemie.",
		},
		modalLoad: {
			title: "Załaduj plik z listą użytkowników (.xlsx)",
			loadFileWithList: "Załaduj plik z listą użytkowników w formacie .xlsx. Plik powinien zawierać 5 kolumn, o takich samych nazwach jak w tabeli na stronie:",
			name: "Imię",
			surname: "Nazwisko",
			email: "E-mail",
			department: "Wydział  (jeżeli użytkownik jest przypisany do więcej niż jednego wydziału, dodaj je po średniku)",
			role: "Rola (Administrator, Ekspert, Redaktor, Czytelnik)",
			danger: "Uwaga! ",
			desc: "Wszystkie kolumny, poza 4 („Wydział”) są obowiązkowe do wypełnienia.",
			info: "Załaduj plik (.xlsx)",
			browse: "Wybierz",
			dragFiles: "lub przeciągnij plik tutaj",
			file: "Wybrany plik:",
			loadedFile: "Dodany plik: ",
			anotherFile: "To nie ten plik? Załaduj inny:",
			warningMessage: {
				part1: "Jeśli są już wprowadzone dane użytkowników, to ",
				part2: " nie zostaną ",
				part3: " one nadpisane po załadowaniu tego pliku. Można je usunąć / edytować tylko w serwisie.",
			},
			info2: "Jeśli przesyłasz plik ponownie, dane istniejących użytkowników nie zostaną nadpisane. Można je edytować bezpośrednio w serwisie.",
			errors: {
				header: "Wystąpił błąd!",
				check: "Sprawdź czy:",
				inRegardsTo: "Dotyczy wierszy:",
				rows: "Nie brakuje obowiązkowych kolumn",
				format: "Dodano plik w prawidłowym formacie (.xlsx.)",
				mandatory: "Obowiązkowe kolumny są wypełnione",
				dataFormat: "Wprowadzone dane są we właściwym formacie",
				limit: "Nie został przekroczony limit użytkowników dla poszczególnych ról",
			},
			limitWarning: {
				part1: "Uwaga: ",
				part2: "do serwisu można dodać maksymalnie ",
				part3: " administratorów, ",
				part4: " ekspertów, ",
				part5: " redaktorów, ",
				part6: " czytelników.",
				part3Singular: " administratora, ",
				part4Singular: " eksperta, ",
				part5Singular: " redaktora, ",
				part6Singular: " czytelnika.",
			},
		},
	},
	letter: {
		metadata: {
			modalTitle: "Metadane pisma",
			editMetadataBtn: "Edytuj metadane",
			title: "Tytuł",
			titleType: "Rodzaj tytułu",
			category: "Kategoria",
			writingDate: "Data pisma",
			writingAuthor: "Autor pisma",
			department: "Wydział",
			recipient: "Odbiorca",
			introductory: "Wprowadzający",
			addedDate: "Data dodania",
			editData: "Data edycji",
			none: "Brak",
		},
		categories: {
			category: 'Kategoria',
			request: 'Wniosek',
			replytorequest: 'Odpowiedź na wniosek',
			application: 'Podanie',
			powerofattorney: 'Pełnomocnictwo',
			refusal: 'Odmowa',
			other: 'Inne',
		},
		template: {
			template: 'Szablon',
			exists: 'Istnieje',
			none: 'Brak',
			createTemplate: 'Utwórz szablon',
			editTemplate: 'Edytuj szablon',
			useTemplateButton: "Użyj szablonu",
		},
		menu: {
			deleteLetter: "Usuń pismo",
			simplifictionPhase: "Etap upraszczania: ",
			finish: "Zakończ",
			continue: "Wznów",
			showMetadata: "Pokaż metadane ",
			useTemplate: "Użyj szablonu",
			noTemplate: "Brak",
			createTemplate: "Utwórz szablon",
			youAreLookingAt: "Przeglądasz",
			template: "Szablon",
			lookUp: "Podgląd",
		},
		info: {
			date: "Data pisma: ",
			author: "Autor pisma: ",
			department: "Wydział: ",
			recipient: "Odbiorca: ",
			initiator: "Wprowadzający: ",
			addDate: "Data dodania: ",
			editDate: "Data edycji: ",
		},
		characters: "Liczba znaków: ",
		charactersMobile: "Znaki: ",
		originalDoc: "Oryginał",
		finalDoc: "Tekst ostateczny",
		simplifiedDoc: "Tekst roboczy",
		modelDoc: "Podgląd pisma wzorcowego",
		suggestButton: "Zaproponuj zmiany automatyczne",
		removeAutoChangesButton: "Usuń zmiany automatyczne",

		contentSimplificationMenu: {
			automaticSimplifications: "Uprość pismo",
			inject: "Wprowadź zmiany automatyczne",
			correct: "Zastosuj korektę językową",
			removeAll: "Usuń wszystkie",
			tooltip: {
				simplifications: "Uproszczenia automatyczne generują się na podstawie Słownika.",
				corrections: "Możesz również zastosować korektę językową tekstu.",
			},
		},

		continueSimplificationBar: {
			text1: "Zakończono upraszczanie",
			text2: "Wznów upraszczanie, jeśli chcesz wprowadzić zmiany",
			button: "Wznów upraszczanie",
		},

		finishSimplificationBar: {
			text1: "Zmiany są zapisywane automatycznie.",
			text2: " Jeśli uważasz, że tekst nie wymaga więcej poprawek:",
			button: "Zakończ upraszczanie",
		},

		popover: {
			addChange: 'Dodaj zmianę',
			addNewChange: 'Dodaj nową zmianę',
			simplify: 'Uprość',
			changeText: 'Zmień treść',
			moveLegalBasis: 'Przenieś podstawę prawną',
			deleteText: 'Usuń',
			comment: 'Jaki rodzaj zmiany chcesz wprowadzić dla tego fragmentu tekstu?',
			changes: 'Zmiany ',
			changesTooltip: 'Zaznaczona zmiana jest wprowadzona do tekstu roboczego',
			deleteNotChosenChanges: 'Usuń niewybrane zmiany automatyczne',
			annotation: 'Przypis',
			contentChanged: 'Zmieniona treść',
			contentRemoved: 'Usunięta treść',
			contentMoved: 'Przeniesiona podstawa prawna',
			automaticChange: 'Zmiana automatyczna',
			redactorChange: 'Zmiana Redaktora',
			reason: 'Uzasadnienie',
			reasonOptional: '(opcjonalne)',
			showReason: "Pokaż uzasadnienie",
			hideReason: "Schowaj uzasadnienie",
			editBtn: 'Edytuj',
			deleteBtn: 'Usuń zmianę',
			reverseMove: 'Cofnij przeniesienie',
			addToDict: 'Dodaj do słownika',
			addingToDict: 'Dodawanie do słownika',
			addedToDict: 'Dodane do słownika',
			confirmDeleteChange: 'Czy na pewno chcesz usunąć wybraną zmianę z historii zmian? Po usunięciu nie będzie ona dłużej możliwa do wprowadzenia.',
			deleteChange: 'Usuń zmianę',
			preview: 'Podgląd',
			previewText: 'Na wersji mobilnej portalu dostępny jest tylko podgląd pisma, nie można proponować zmian w piśmie. Jeśli chcesz pracować z tekstem i wprowadzać swoje propozycje zmian otwórz projekt na urządzeniu, którego rozdzielczość jest większa niż 1024px (teblety, laptopy oraz wszystkie komputery stacjonarne).',
		},
		editor: {
			changeContent: 'Tutaj wpisz zmienioną treść',
			annotation: 'Tutaj wpisz przypis',
			reason: 'Tutaj wpisz uzasadnienie',
		},
		footer: {
			t1: 'Proste Pismo zostało wykonane przez ',
			t2: 'Poznańskie Centrum Superkomputerowo-Sieciowe ',
			t3: 'w porozumieniu z ',
			t4: 'Urzędem Miasta Poznania ',
			t5: 'oraz ',
			t6: 'Uniwersytetem im. Adama Mickiewicza.',
			t7: "Informacje o plikach",
			t8: "Cookies.",
			t9: "w",
		},
		explanationPanel: {
			text: {
				part1: "Dla każdej frazy można zaproponować wiele uproszczeń - w sposób ręczny (przez redaktora) lub automatyczny (jeżeli uproszczenie zostanie znalezione np. w",
				part2: "Słowniku",
				part3: ").",
				part4: " - oznacza, że wybrano uproszczenie redaktora, a",
				part5: " - oznacza, że wybrano uproszczenie automatyczne.",
				part6: " Liczba wskazuje ile propozycji uproszczeń dodano. Kliknij w nią, aby je zobaczyć.",
			},
			button: " Zobacz jak działa upraszczanie pism",
		},
	},
	letters: {
		letters: 'Pisma',
		description: 'Znajdziesz tutaj uproszczone pisma urzędowe, które możesz wykorzystać w pracy - pobierając je lub używając szablonów stworzonych na ich podstawie. ',
		descriptionRedactor: 'Dodawaj, upraszczaj i zarządzaj własnymi pismami,  a także przeglądaj i pobieraj pozostałe. Na podstawie pism w wersji ostatecznej możesz stworzyć szablony lub korzystać z już powstałych.',
		descriptionAdministrator: 'Dodawaj, upraszczaj i zarządzaj wszystkimi pismami. Na podstawie pism w wersji ostatecznej możesz stworzyć szablony lub korzystać z już powstałych.',
		search: 'Wyszukaj',
		searchLabel: 'Wyszukaj pismo po tytule lub treści',
		initiator: 'Wprowadzający',
		dept: 'Wydział',
		version: 'Etap upraszczania',
		recipient: 'Odbiorca',
		searchByInitiator: 'Wprowadzający',
		searchByDepartment: 'Wydział',
		autocompletePlaceholder: 'Wpisz lub wybierz z listy',
		allVersions: "Wszystkie etapy",
		allRecipients: "Wszyscy odbiorcy",
		allCategories: "Wszystkie kategorie",
		noElements: 'Brak pism spełniających określone kryteria wyszukiwania.',
		defaultDeptTooltip: 'Domyślnie wyświetlane są pisma pochodzące z wydziału, do którego należysz.',
		table: {
			title: 'Tytuł pisma',
			date: 'Data pisma',
			addDate: 'Data dodania',
			editDate: 'Data edycji',
			version: 'Etap',
			versionTooltip: 'Na etapie upraszczania: „W trakcie” liczba w nawiasie wskazuje ile do tej pory wprowadzono zmian.',
			category: 'Kategoria',
			template: 'Szablon',
		},
		menu: {
			editMetadata: "Edytuj metadane",
			deleteDisabledTooltip: "Z tym pismem powiązany jest szablon - najpierw usuń szablon, a dopiero potem pismo.",
			delete: "Usuń",
		},
	},
	addLetter: {
		addLetter: "Dodaj pismo",
		dragFiles: "<span>Wybierz</span> lub przeciągnij plik tutaj",
		selectedFile: "Wybrany plik: ",
		fieldsRequired: "* Pola wymagane",
		warn1: "Pamiętaj: ",
		warn2: "w systemie obowiązuje zakaz umieszczania danych osobowych. Wszystkie dane osobowe powinny zostać przez Ciebie zanonimizowane.",
		docx: " (.docx) *",
		selectFile: "wybierz plik",
		addedFile: "Dodany plik:",
		simplifiedTextWithAI: {
			part1: "Udało się!",
			part2: "Załadowano plik z tekstem uproszczonym z AI",
		},
		simplifiedTextWithAIError: {
			part1: "Wystąpił błąd:",
			part2: "Nie udało się załadować pliku z tekstem uproszczonym z AI",
		},
		title: "Tytuł",
		titlePlaceholder: "Wpisz tytuł pisma",
		titleNote: "Jeśli nie podasz tytułu to tytułem będzie incipit.",
		titleType: "Rodzaj tytułu",
		titleTypes: "Rodzaje tytułów:",
		category: "Kategoria *",
		original: "Pierwotny",
		granted: "Nadany",
		incipit: "Incipit",
		letterDate: "Data powstania pisma",
		datePlaceholder: "Kliknij, aby wybrać datę",
		letterAuthor: "Autor pisma",
		letterAuthorAdditionalInfo: "Wprowadź w przypadku, kiedy to nie Ty jesteś autorem oryginalnej treści pisma.",
		forename: "Imię",
		surname: "Nazwisko",
		department: "Wydział *",
		recipient: "Odbiorca *",
		cancel: "Anuluj",
		add: "Dodaj",
		editTitle: 'Edytuj metadane pisma',

		titleTypesDescription: {
			original: 'pierwotny - oryginalny,',
			given: 'nadany - zmieniony przez wprowadzającego,',
			incipit: 'incipit - występuje kiedy tytuł nie został podany podczas dodawania pisma i jest to pierwsza fraza w piśmie',
		},

		errors: {
			wrongFormat: {
				part1: "Wystąpił błąd:",
				part2: "Dodano plik w nieprawidłowym formacie.",
				part3: "Wspieramy tylko format: .docx.",
			},
			required: "Pole wymagane",
			conditionallyrequired1: 'Pole wymagane jeśli rodzaj tytułu podany',
			conditionallyrequired2: 'Pole wymagane jeśli tytuł podany',
			fieldincorrectdocx: 'Nieprawidłowy format pliku. System importuje jedynie pliki MsWord 2016 z rozszerzeniem .docx.',
			fieldinvaliddocx: 'Nieprawidłowy format pliku. System importuje jedynie pliki MsWord 2016 z rozszerzeniem .docx. Dołączony plik nie został zapisany w tym edytorze.',
			fieldnotExist: 'Dokument jest pusty',
		},
	},
	sensitiveDataReport: {
		dictHeaderInfo: "Raport dotyczący danych wrażliwych",
		dictReportPrepareBtn: "Przygotuj raport",
		dictReportDownloadBtn: "Pobierz raport",
	},
	login: {
		tLoginPageTitle: 'Zaloguj się',
		tLogin: 'E-mail (login)',
		tLoginPlaceholder: 'Wpisz swój e-mail',
		tPassword: 'Hasło',
		tPasswordPlaceholder: 'Wpisz hasło',
		tLog: 'Zaloguj',
		tNoUser: 'Błędne hasło lub nazwa użytkownika',
		tResetPassword: 'Nie pamiętam hasła',
		tOr: 'Lub',
		tMimLogin: 'Zaloguj się przez MIM',
	},
	resetPassword: {
		tResetPasswordPageTitle: 'Nie pamiętam hasła',
		tResetPasswordInfo: 'Wprowadź poniżej adres e-mail, dla którego zostało utworzone Twoje konto. Wyślemy na niego link, który pozwoli na zmianę hasła.',
		tLogin: 'E-mail (login)',
		tLoginPlaceholder: 'Wpisz swój e-mail',
		tSendBtn: 'Wyślij link',
		tBackToLogin: 'Wróć do logowania',
		tEmailSent: 'Wysłaliśmy link na podany adres e-mail. Sprawdź swoją pocztę.',
		tUnknownError: 'Nastąpił błąd.',
		errors: {
			tFieldRequired: "To pole jest obowiązkowe",
			tWrongEmailFormat: 'Niepoprawny format email',
		},
	},
	changePassword: {
		tChangePassword: "Zmień hasło",
		tOldPassword: "Stare hasło",
		tNewPassword: "Nowe hasło",
		tRepeatNewPassword: "Powtórz hasło",
		tPasswordInfo: "Hasło powinno składać się z minimum 8 znaków, w tym z wielkiej litery i cyfry.",
		tSetPasswordBt: "Ustaw hasło",
		tEnterOld: "Wpisz stare hasło",
		tEnterNew: "Wpisz nowe hasło",
		tEnterRepeat: "Powtórz nowe hasło",
		errors: {
			tFieldRequired: "To pole jest obowiązkowe",
			tMinChars: "Hasło musi mieć minimum 8 znaków",
			tRules: "Hasło musi zawierać przynajmniej jedną wielką literę i jedną cyfrę",
			tMatch: "Hasła nie są zgodne",
		},
		tChangePasswordSuccess: "Hasło zostało zmienione pomyślnie. Zaloguj się używając nowego hasła.",
		tChangePasswordError: "Podane stare hasło nie jest poprawne",
		tChangePasswordUnknownError: "Nastąpił błąd, proszę spróbować później",
		tSetPassword: "Ustaw hasło",
		tFieldRequired: "* Pole wymagane",
		tTokenExpired: "Token wygasł",
	},
	modals: {
		onboarding: {
			skip: "Pomiń wprowadzenie",
			previous: "Cofnij",
			next: "Dalej",
			page0: {
				header: "Witaj w Prostym Piśmie",
				text: "Poznaj narzędzie, które pomoże Ci uczynić dokumenty urzędowe prostsze i bardziej zrozumiałe w odbiorze.",
				button: "Poznaj najważniejsze funkcje",
			},
			page1: {
				header: "Pisma",
				text: "W bazie pism znajdziesz pisma urzędowe, które zakończono upraszczać lub są w trakcie upraszczania. Po przejściu do szczegółów wybranego pisma:",
				list: {
					part1: "Porównasz tekst przed (Oryginał) i po uproszczeniu (Tekst roboczy, Tekst ostateczny).",
					part2: "Sprawdzisz historię wprowadzonych uproszczeń w lewym oknie (Oryginał).",
					part3: "Pobierzesz wybraną wersję tekstu.",
				},
			},
			page2: {
				header: "Dodawanie i upraszczanie pism",
				text: {
					part1: "Jeśli masz uprawnienia redaktora",
					part2: " możesz także dodawać pisma i je upraszczać. Pismo dodasz uzupełniając formularz dostępny pod przyciskiem „Dodaj pismo”, na stronie Pism. Uproszczenia możesz wprowadzić w szczegółach wybranego pisma w sposób ręczny lub poprzez wybranie opcji „Wprowadź uproszczenia automatyczne”.",
				},
			},
			page3: {
				header: "Korzystanie z szablonów i ich tworzenie",
				text: {
					part1: "Jeżeli wybrane pismo ma utworzony szablon, to na liście pism będzie dostępny przycisk ",
					part2: "„Użyj szablonu”",
					part3: ". Wówczas możesz taki szablon uzupełnić, aby utworzyć własne pismo. Wszystkie dostępne szablony sprawdzisz przechodząc do ",
					part4: "„Szablony”",
					part5: "Jeśli masz uprawnienia redaktora",
					part6: " możesz także tworzyć szablony na podstawie własnych pism. Ta opcja będzie dostępna po ukończeniu upraszczania danego pisma.",
				},
			},
			page4: {
				header: "Upraszczenie z AI",
				text: {
					part1: "Uprość z AI to narzędzie wykorzystujące sztuczną inteligencję do upraszczania tekstów. Możesz je wypróbować wpisując lub wklejając tekst/plik do okna po lewej „Tekst do uproszczenia”. Uproszczony tekst pojawi się w oknie po prawej. Znajdziesz tam także ocenę uproszczenia i jej interpretację. Taki tekst możesz skopiować i użyć lokalnie.",
					part2: "Jeśli masz uprawnienia redaktora",
					part3: " możesz także zapisać uproszczony tekst w bazie pism i kontynuować pracę nad upraszczaniem w głównym narzędziu.",
				},
			},
			page5: {
				header: "Poradnia Prostego Pisma",
				text: {
					part1: "W Poradni Prostego Języka znajdziesz porady językowe udzielane przez ekspertów. Odpowiadają one na wątpliwości i problemy z użyciem prostego języka w pismach urzędowych. ",
					part2: "Jeśli masz uprawnienia redaktora",
					part3: " możesz także zadawać swoje pytania.",
				},
				button: "Rozpocznij pracę z Prostym Pismem",
			},
		},
		simplifying: {
			skip: "Pomiń wprowadzenie",
			previous: "Cofnij",
			next: "Dalej",
			page0: {
				header: "Upraszczanie pism w 5 krokach",
				text: "Dowiedz się jak działa upraszczanie pism w Prostym Piśmie.",
				button: "Zobacz krok 1",
			},
			page1: {
				header: "1. Układ strony - lewe i prawe okno",
				text: {
					part1: "W lewym oknie" ,
					part2: " znajdziesz oryginalną treść pisma, gdzie można zapoznać się z historią zmian oznaczonych fragmentów tekstu. Jeśli masz uprawnienia redaktora w tym oknie wprowadzisz też zmiany w tekście.",
					part3: "W prawym oknie",
					part4: " znajdziesz 2 zakładki. Pierwsza: „Tekst roboczy” jest aktywna w trakcie upraszczania i dostępny jest w niej aktualny podgląd zmian w tekście. Druga zakładka: „Tekst ostateczny” będzie aktywna po zakończeniu upraszczanie.",
				},
			},
			page2: {
				header: "2. Uproszczenia wprowadzone przez redaktora",
				text: {
					part1: "Aby wprowadzić zmiany ręcznie trzeba zaznaczyć tekst. Otworzy się wtedy okienko z 3 opcjami do wyboru:",
					part2: "Fragment tekstu zmieniony przez redaktora jest oznaczony kolorem różowym i literą R.",
				},
				list: {
					part1: "zmień treść (w zaznaczonym fragmencie tekstu),",
					part2: "przenieś podstawę prawną (do ostatniego akapitu),",
					part3: "usuń (zaznaczony fragment tekstu).",
				},
			},
			page3: {
				header: "3. Uproszczenia automatyczne",
				text: {
					part1: "Wprowadzenie tych uproszczeń automatycznie zmieni treść takich słów lub fraz, dla których zostanie znalezione uproszczenie w Słowniku.  ",
					optionalPartA: "W tej sekcji dostępna jest również korekta językowa obejmująca poprawę pisowni i gramatyki.",
					part2: "Automatycznie zmieniony fragment tekstu zostanie oznaczony kolorem niebieskim i literą A.",
				},
			},
			page4: {
				header: "4. Zakończenie i wznowienie uproszczenia",
				text: {
					part1: "Jeżeli pismo nie wymaga więcej zmian, zakończ upraszczanie. Możesz to zrobić na 2 sposoby:",
					part2: "Po zakończeniu upraszczania jest możliwość jego wznowienia.",
					part3: "Wówczas tekst ostateczny będzie oznaczony jako nieaktualny dopóki ponownie nie zakończysz upraszczania.",
				},
				list: {
					part1: "zatwierdź wersję roboczą jako ostateczną, lub",
					part2: "pobierz wersję roboczą, aby lokalnie wprowadzić do niej poprawki, których nie można zrobić w systemie. Po załadowaniu nowego pliku, zostanie on dołączony do szczegółów pisma jako tekst ostateczny.",
				},
			},
			page5: {
				header: "5. Tworzenie szablonów",
				text: {
					part1: "Utworzenie szablonu na podstawie pisma jest możliwe tylko po zakończeniu procesu upraszczania. Po kliknięciu w „Utwórz szablon” zostaniesz przeniesiony do formularza, za pomocą którego zdecydujesz o zawartości szablonu i go udostępnisz.",
					part2: "Pamiętaj, że jeżeli wznowisz upraszczanie po wcześniejszym utworzeniu szablonu, będzie on wymagał aktualizacji.",
				},
				button: "Rozpocznij upraszczanie",
			},
		},
		importFinalVersion: {
			importFinalVersion: "Zakończ upraszczanie",
			description: "Po zakończeniu upraszczania nie będzie możliwości wprowadzania zmian w piśmie, tak długo aż tego procesu nie wznowisz. Zakończenie umożliwi pobranie wersji ostatecznej, a także utworzenie szablonu. ",
			acceptWorkingVersion: "Zatwierdź wersję roboczą jako ostateczną ",
			acceptWorkingVersionDescription: "Obecna wersja robocza nie wymaga więcej poprawek do wprowadzenia i można ją uznać za ostateczną. ",
			importFile: "Importuj pismo w wersji ostatecznej",
			importFileDescription1: "Pobierz tekst roboczy",
			importFileDescription2: ", aby lokalnie wprowadzić do niego korekty, których nie możesz zrobić w systemie. Poprawiony tekst zaimportuj jako pismo w wersji ostatecznej.", 
			finishSimplificationButton: "Zakończ upraszczanie",
			addFile: "Załaduj plik",
		},
		deleteLetter: {
			head: 'Usuń pismo',
			comment1: 'Czy na pewno chcesz usunąć pismo?',
			comment2: 'Wszystkie zapisane przez Ciebie zmiany zostaną usunięte.',
			delete: 'Usuń pismo',
		},
		deleteTemplate: {
			head: 'Usuń szablon',
			comment1: 'Czy jesteś pewien, że chcesz usunąć szablon?',
			comment2: 'Wszystkie zapisane przez Ciebie zmiany zostaną usunięte.',
			delete: 'Usuń',
		},
		continueSimplification: {
			head: 'Wznów upraszczanie',
			text: 'Z tym pismem jest powiązany szablon. Na czas upraszczania pisma do szablonu zostanie dołączony komunikat informujący o jego nieaktualności. Pamiętaj o zakończeniu upraszczania po wprowadzeniu poprawek i aktualizacji szablonu.',
			button: 'Wznów upraszczanie',
		},
		checkTemplateAfterSimplification: {
			head: 'Zaktualizuj szablon',
			text: 'Zakończono upraszczanie pisma. Pamiętaj, aby zaktualizować szablon, utworzony na jego podstawie.',
			cancel: 'Szablon nie wymaga aktualizacji',
			button: 'Zaktualizuj szablon',
		},
		howToCreateSimpleTexts: {
			head: 'Jak tworzyć proste teksty urzędowe?',
			listStart: 'Treść pisma urzędowego powinna zawierać tylko najważniejsze informacje, przekazane w najprostszej i czytelnej formie. Aby to zrobić stosuj te zasady:',
			list1: 'Podziel tekst na akapity, a najważniejszą informację podaj na początku pisma.',
			list2: 'Stosuj śródtytuły tam, gdzie to możliwe.',
			list3: 'Stosuj wypunktowania i numerację.',
			list4: 'Podstawę prawną podaj niżej, w sekcji „Podstawa prawna”. Pojawi się na końcu tekstu.',
			list5: 'Zwracaj się bezpośrednio do odbiorcy. Pisz w pierwszej osobie jako „ja” lub „my”.',
			list6: 'Podawaj tylko najistotniejsze treści. Jasno określaj, co odbiorca ma zrobić.',
			list7: 'Pisz krótkie zdania. Stosuj „kropkę miłości” w długich i rozbudowanych zdaniach.',
			list8: 'Stosuj naturalny szyk zdania. Rzeczownik (kto, co), czasownik (co robi), dopełnienie (reszta zdania).',
			list9: 'Unikaj urzędyzmów i staraj się wyjaśniać trudne terminy.',
			list10: 'Używaj prostych i dobrze znanych słów.',
			moreTips: 'Więcej wskazówek znajdziesz w:',
			link1: 'Instrukcja prostego pisania (PDF)',
			link2: 'Poradnik: Prosty język w pismach urzędowych (PDF)',
		},
	},
	titletypes: {
		original: "Pierwotny",
		granted: "Nadany",
		incipit: "Incipit",
	},
	versions: {
		original: "Nierozpoczęty",
		simplified: "W trakcie",
		aicreated: "Uproszczony z AI",
		final: "Zakończony",
	},

	recipients: {
		thisauthority: 'Ten urząd',
		citizen: 'Obywatel',
		company: 'Firma',
		media: 'Media',
		institution: 'Instytucja',
	},

	pagination: {
		previous: 'Poprzednia',
		next: 'Następna',
		of: ' z ',
		sort: "Sortuj",
	},

	sortOptions: {
		accuracy: 'Trafność',
		lastModified: 'Ostatnio edytowane',
		department: 'Wydział A - Z',
		departmentReverse: 'Wydział Z - A',
		departmentName: 'Nazwa wydziału A - Z',
		departmentNameReverse: 'Nazwa wydziału Z - A',
		title: 'Tytuł pisma A - Z',
		titleReverse: 'Tytuł pisma Z - A',
		originalPhrase: 'Oryginalne słowo/fraza A - Z',
		originalPhraseReverse: 'Oryginalne słowo/fraza Z - A',
		simplification: 'Uproszczenie A - Z',
		simplificationReverse: 'Uproszczenie Z - A',
		template: 'Nazwa szablonu A - Z',
		templateReverse: 'Nazwa szablonu Z - A',
		surname: 'Nazwisko A - Z',
		surnameReverse: 'Nazwisko Z - A',
	},

	cookiesInfo: {
		title: 'Cookies',
		text: 'Jeśli chciałbyś ograniczyć, zablokować lub usunąć pliki cookies, możesz to zrobić za pomocą ustawień twojej przeglądarki. Funkcja Pomoc przeglądarki podpowie Ci jak to zrobić. Możesz także odwiedzić stronę wszystko o ciasteczkach by dowiedzieć się jak zarządzać i usuwać cookies w różnych przeglądarkach internetowych. Informacje o zarządzaniu cookies na twoim urządzeniu mobilnym znajdziesz w instrukcji obsługi tego urządzenia.<br><br>Musisz jednak pamiętać, że niektóre obszary portalu mogą być dostępne wyłącznie z włączonymi plikami cookies. Musisz być świadomy, że wyłączenie plików cookies może uniemożliwić dostęp do niektórych treści i czerpanie z pełnych możliwości portalu.',
	},

	cookies: {
		title: 'Używamy plików cookies',
		text1: 'Używamy plików ',
		text2: ', by ułatwić korzystanie z naszego serwisu. Jeżeli nie chcesz, by pliki cookies były zapisywane na Twoim dysku, zmień ustawienia swojej przeglądarki.',
		link: 'Cookies',
		agree: 'Rozumiem',
	},

	simpletext: {
		title: "Uprość z AI",
		description: "Uprość tekst z pomocą sztucznej inteligencji. Wprowadzone teksty i wynik ich uproszczenia nie będą przechowywane w systemie.",
		loadingText: "W zależności od wybranego modelu oraz długości tekstu przetwarzanie może chwilę potrwać. Orientacyjny czas oczekiwania wynosi od 5 sekund do 2 minut.",
		editorDescription1: "Uprość tekst z pomocą sztucznej inteligencji. Wynik możesz zapisać w bazie Pism i tam kontynuować upraszczanie.",
		editorDescription2: "Jeżeli się na to nie zdecydujesz, wprowadzone teksty i wynik ich uproszczenia nie będą przechowywane w systemie. ",
		error1: "Błąd: ",
		warning1: "Pamiętaj: ",
		warning2: " w systemie obowiązuje zakaz umieszczania danych osobowych. Wszystkie dane osobowe powinny zostać przez Ciebie zanonimizowane.",
		buttons: {
			clear: "Wyczyść tekst",
			convert: "Uprość tekst",
			copy: "Kopiuj tekst",
			saveText: "Zapisz tekst w bazie Pism",
		},
		tabText: "Tekst do uproszczenia",
		tabText2: "Uproszczony tekst",
		words: "Słów:",
		avoid: "Jak korzystać z narzędzia Uprość z AI?",
		placeholderText: "Wklej lub wpisz tekst, który chcesz uprościć. Aby osiągnąć najlepsze rezultaty, podziel tekst na krótkie fragmenty (akapity) - za pomocą dwukrotnego ENTER.",
		dropzone: {
			info: "Kliknij tutaj, aby przesłać plik z tekstem (.docx) lub przeciągnij go",
		},
		copyText: "Skopiowano uproszczony tekst",
		useModel: "Zastosuj model AI",
		indexesHelp: {
			description: {
				part1: "Ocena tekstów jest obliczana na podstawie ",
				part2: "2 wskaźników trudności tekstu i jego długości",
				part3: ". Im wyższy dany wskaźnik, tym trudniejszy tekst, ale liczba słów też ma znaczenie.",
			},
			pisarek: {
				part1: "Indeks Pisarka",
				part2: " - uwzględnia długość zdań i liczbę trudnych wyrazów; ",
			},
			fog: {
				part1: "Wskaźnik mglistości (FOG Index)",
				part2: " - uwzględnia liczbę wszystkich słów, długich słów i zdań w tekście.",
			},
		},
		stats: {
			hideDetails: "Ukryj wyjaśnienie wskaźników",
			showDetails: "Pokaż wyjaśnienie wskaźników",
			easyText: "Prosty tekst",
			hardText: "Trudny tekst",
			difficultyRatingBadge: "Tekst do uproszczenia",
			simplifiedRatingBadge: "Uproszczony tekst",
			pisarekIndex: "Indeks Pisarka",
			fogIndex: "Wskaźnik mglistości (Fog Index)",
			simplifyNewText: "Uprość nowy tekst",
		},
		tips: {
			title: "Jak korzystać z narzędzia Uprość z AI?",
			part1: "Oto kilka wskazówek, które pomogą Ci uzyskać najlepsze efekty w upraszczaniu tekstu:",
			part2: "Moduł „Uprość z AI” wykorzystuje sztuczną inteligencję do upraszczania tekstów.",
			part3: "Narzędzie nie jest doskonałe, dlatego za każdym razem sprawdź jego wyniki.",
			part4: "Jeśli efekt upraszczania nie spełni Twoich oczekiwań, możesz podzielić tekst na mniejsze fragmenty (akapity) i wybrać lepsze rozwiązanie.",
			part5: "Pamiętaj, że poprawne zdania powinny kończyć się kropką, znakiem zapytania lub wykrzyknikiem.",
			part6: "Uwaga!",
			part7: " To Ty ostatecznie akceptujesz zalecane uproszczenia.",
			part8: "Jeśli masz uprawnienia redaktora:",
			part9: "Możesz zapisać uproszczony tekst w bazie pism, aby tam kontynuować pracę nad jego upraszczaniem. ",
			part10: "Jeżeli nie zdecydujesz się przenieść tekstu do bazy pism, teksty podlegające upraszczaniu, jak i teksty wynikowe nie będą przechowywane w systemie i nie będą w żaden sposób dalej przetwarzane.",
		},
	},

	footer: {
		title: "Mapa strony",
		links: {
			letters: "Pisma",
			templates: "Szablony",
			simpletext: "Uprość z AI",
			dictionary: "Słownik",
			myAccount: "Moje konto",
			listUsers: "Użytkownicy",
			listDeps: "Wydziały",
			changePassword: "Zmień hasło",
			serviceManagement: "Zarządzanie serwisem",
			ppjLabel: "Poradnia Prostego Języka",
			findAdvice: "Znajdź poradę",
			myQuestions: "Moje pytania",
			askQuestion: "Zadaj pytanie",
			manageQuestions: "Zarządzaj pytaniami",
		},

	},

	simpleTextAdvices: {
		findAdvice: {
			header: "Poradnia Prostego Języka",
			subHeader: "Znajdź poradę",
			description: "Znajdziesz tutaj opublikowane porady dotyczące redagowania pism urzędowych zgodnie z prostym językiem.",
			randomAdvice: "Zobacz losową poradę",
			myQuestions: "Zobacz Moje pytania",
			category: "Kategorie",
			checkMark: 'Zaznaczenie',
			advices: "Porady",
			allCategories: "Wszystkie kategorie",
			alert: {
				category: "Wysątpił błąd podczas pobierania kategorii. Spróbuj ponownie",
				questions: "Wysątpił błąd podczas pobierania pytań. Spróbuj ponownie",
			},
		},
		advice: {
			back: "Przejdź do: Znajdź poradę",
			nextAdvice: "Zobacz kolejne pytanie w tej kategorii",
			delete: "Usuń pytanie",
			backAdmin: "Przejdź do: Panel zarządzania",
			backMyAdvices: "Przejdź do: Moje pytania",
			backAdvices: "Przejdź do: Znajdź poradę",
		},
		comments: {
			title: "Komentarze",
			addLabel: "Treść komentarza",
			info: "Masz jeszcze jakieś wątpliwości dotyczące tego zagadnienia? Dodaj komentarz. Powiadomienie o odpowiedzi otrzymasz mailowo.",
			buttons: {
				edit: "Edytuj",
				close: "Zamknij",
				delete: "Usuń",
				editComment: "Edytuj komentarz",
				addComment: "Dodaj komentarz",
			},
			enterCommentPlaceholder: "Tutaj wpisz swój komentarz",
			errorRequaired: "Pole jest wymagane",
		},
		question: {
			title: "Pytanie",
			statusLabel: "Status porady:",
			contentLabel: "Treść porady *",
			categoryLabel: "Kategoria pytania *",
			category: "Przyznana kategoria:",
			fragment: "Fragment tekstu, którego dotyczy pytanie:",
			date: "Pytanie przesłane:",
			advice: "Porada",
			adviceDate: "Porada otrzymana:",
			advisor: "Radzi:",
			viewQuestionDetails: "Zobacz szczegóły pytania",
			viewAdviceDetails: "Zobacz poradę",
			noAdviceEditor: "Kiedy ekspert językowy udzieli odpowiedzi, porada będzie widoczna tutaj. Otrzymasz także powiadomienie na maila.",
			noAdviceAdmin: "Nie udzielono jeszcze odpowiedzi na to pytanie. ",
			published: "Opublikowana",
			unpublished: "Nieopublikowana",
			waiting: "Oczekiwanie na odpowiedź",
			inProgress: "W trakcie udzielania odpowiedzi",
			read: "Odczytana",
			unread: "Nieodczytana",
			alt: {
				confirm: "potwierdzenie",
				info: "Ikona informacji",
			},
			button: {
				editQuestion: "Edytuj pytanie",
				editAnswer: 'Edytuj odpowiedź',
				giveAnswer: "Udziel odpowiedzi",
				close: "Zamknij wątek",
				unpublish: "Przestań publikować",
				publish: "Opublikuj pytanie",
				uam: "Przekaż do Poradni UAM",
			},
			alert: {
				added: "Udało się! Treść odpowiedzi została zmieniona.",
				answered: "Udało się! Odpowiedź została dodana",
				uam: "Pytanie zostało przekazane do Poradni UAM",
				unpublished: 'Pytanie przestało być publikowane',
				published: 'Pytanie zostało opublikowane',

			},
		},
		myAdvices: {
			recived: "Otrzymane porady",
			waiting: "Oczekujące na poradę",
			description1: "Znajdziesz tutaj odpowiedzi na swoje pytania, udzielone przez ekspertów językowych.",
			description2: "Eksperci poza udzieleniem odpowiedzi, przypisują poradzie kategorię i mogą zdecydować o jej publikacji.",
			subTitle: "Moje pytania",
			empty: "Brak pytań w danym statusie",
			buttons: {
				back: "Przejdź do: Znajdź poradę",
				newQuestion: "Zadaj nowe pytanie",
			},
		},
		addQuestion: {
			preTitle: "Poradnia Prostego Języka",
			required: "Pole jest wymagane",
			addLabel: "Zadaj pytanie",
			askLabel: "Zadaj pytanie",
			editLabel: "Edytuj pytanie",
			textLabel: "Treść pytania *",
			fragmentLabel: "Fragment pisma, którego dotyczy pytanie",
			fragmentPlaceholder: "Tutaj wpisz lub wklej fragment tekstu, którego dotyczy pytanie",
			editButton: "Zapisz zmiany",
			UAMButton: "Zapisz zmiany i przekaż do Poradni",
			descriptionAdd: "Uzupełnij formularz, aby zadać pytanie ekspertom językowym.",
			descriptionEdit: "Zmień treść pytania, jeżeli uważasz, że zawiera treści, które nie powinny zostać opublikowane.",
			alert: {
				uam: "Pytanie zostało zmienione i przekazane do Poradni UAM",
				edit: "Pytanie zostało zmienione",
				add: "Udało się! Twoje pytanie zostało dodane!",
			},
		},
		modalUAM: {
			confirm : "Przekaż do Poradni UAM",
			preTitle: "Poradnia Prostego Języka",
			title: "Przekaż do Poradni UAM",
			description: "Czy na pewno chcesz przekazać pytanie do Poradni UAM?",
			alert: "Pytanie zostało przekazane do Poradni UAM",
		},
		modalClose: {
			preTitle: "Poradnia Prostego Języka",
			title: "Zamknij pytanie",
			description: "Czy napewno chcesz zamknąć pytanie? Możliwość komentowania zostanie wyłączona.",
			alert: {
				closed: 'Pytanie zostało zamknięte',
			},
		},
		modalDelete: {
			confirm: "Usuń pytanie",
			title: "Usuń pytanie",
			description: "Czy na pewno chcesz usunąć to pytanie? Jeżeli to zrobisz, pytanie nie będzie dłużej dostępne, a autor/ka pytania otrzyma maila z informacją: „Pytanie zostało usunięte ze względu na powtórzoną lub niezgodną z kontekstem treść. Sprawdź, czy nie udzielono już porady na Twoje pytanie lub zmień jego treść. ” i treścią pytania.",
			preTitle: "Poradnia Prostego Języka",
			alert: {
				deleted: 'Pytanie zostało usunięte',
			},
		},
		admin: {
			title1Uam: "Zarządzaj pytaniami przesłanymi przez redaktorów: edytuj, przekaż do Poradni UAM lub jeżeli są w zakresie Twoich",
			title1: "Zarządzaj pytaniami przesłanymi przez redaktorów: edytuj, odpowiedz, usuwaj.",
			title2Uam: "kompetencji - odpowiedz, usuwaj. Pytania, na które udzielono odpowiedzi możesz publikować lub decydować",
			title2: "Pytania, na które udzielono odpowiedzi możesz publikować lub decydować o zaprzestaniu ich publikacji.",
			title3Uam: "o zaprzestaniu ich publikacji.",
			subTitle: "Zarządzanie",
			sort: "Sortuj",
			question: "Pytanie",
			manageMenu: {
				edit: "Edytuj pytanie",
				answer: "Udziel odpowiedzi",
				uam: "Przekaż do Poradni UAM",
				delete: "Usuń pytanie",
			},
			tab: {
				submitted: "Zgłoszone",
				inProgress: "W trakcie",
				unpublished: "Nieopublikowane",
				published: "Opublikowane",
			},
			tablePublish: {
				question: "Pytanie",
				button: {
					publishAll: "Opublikuj zaznaczone",
					unpublishAll: "Przestań publikować zaznaczone",
					publish:'Opublikuj',
					unpublish: 'Przestań publikować',
				},
				label: {
					id: "ID PYTANIA",
					provider: "WPROWADZAJĄCY",
					department: "WYDZIAŁ",
					sendDate: "DATA PRZESŁANIA",
					responser: "ODPOWIADAJĄCY",
					comments: "LICZBA KOMENTARZY",
				},
			},
			tableSubmited: {
				question: "Pytanie",
				label: {
					id: "ID PYTANIA",
					provider: "WPROWADZAJĄCY",
					department: "WYDZIAŁ",
					sendDate: "DATA PRZESŁANIA",
					editionDate: "DATA EDYCJI",
				},
			},
			alert: {
				published: 'Pytanie zostało opublikowane',
				unpublished: 'Pytanie przestało być publikowane',
			},
		},
	},

	report: {
		title: 'Raport o danych osobowych',
		description: 'Przygotuj plik w formacie .xlsx z raportem o danych osobowych zawartych w pismach. Generowanie raportu może potrwać do kilku godzin.',
		generate: 'Wygeneruj raport',
		inProgress: 'Trwa generowanie raportu...',
		ready: 'Raport jest gotowy do pobrania',
		download: 'Pobierz raport (.xlsx)',
		error: 'Błąd: ',
	},

	templatesManagement: {
		title: 'Zarządzanie szablonami',
		description: 'Zarządzaj metrykami dla szablonów: zmieniaj ich treść, usuwaj, dodawaj nowe. Zarządzaj też czcionką w generowanych dokumentach szablonów.',
		metrics: {
			textField: 'Pole tekstowe',
			date: 'Data',
			title: 'Zawartość metryki pisma (dotyczy szablonów)',
			edit: 'Edytuj',
			type: 'Typ',
			label: 'Etykieta',
			labelFieldPlaceholder: 'Tutaj wpisz nazwę etykiety',
			placeholder: 'Przykładowa treść',
			placeholderFieldPlaceholder: 'Tutaj wpisz przykładową treść',
			deleteMetric: 'Usuń metrykę',
			addMetric: '+ Dodaj nową metrykę',
			cancel: 'Anuluj',
			saveChanges: 'Zapisz zmiany',
		},
		fonts: {
			title: 'Czcionka w generowanych szablonach',
			edit: 'Edytuj',
			type: 'Typ',
			size: 'Rozmiar',
			titleSize: 'Tytuł (H1)',
			headerSize: 'Nagłówek (H2)',
			regularTextSize: 'Zwykła treść',
			interline: 'Interlinia',
			cancel: 'Anuluj',
			saveChanges: 'Zapisz zmiany',
		},
	},
};

export const standalone = {
	header: {
		menu: {
			myAccount: {
				options: {
					tDepartmentList: "Organizacje",
				},
			},
		},
	},
	templates: {
		defaultDeptTooltip: 'Domyślnie wyświetlane są szablony pochodzące z organizacji, do której należysz.',
		card: {
			department: "Organizacja",
		},
		create: {
			department: 'Organizacja *',
			departmentCom: 'Określ do jakiej organizacji należy szablon',
			footer: 'Organizacja dla stopki',
			header: 'Organizacja dla nagłówka',
			headerAndFooterSameAsLetter: 'Zastosuj nagłówek i stopkę zgodne z wybraną organizacją',
		},
		use: {
			dept: 'Organizacja',
			downloadInfo: {
				part5: ' px dla informacji w metryce. Może być dodatkowo uzupełnione o grafiki dla nagłówka i stopki charakterystyczne dla danej organizacji.',
			},
		},
	},
	departments: {
		departments: "Organizacje",
		description1: "Zarządzaj organizacjami, do których redaktorzy mogą przypisać pisma i szablony. Po ich dodaniu możesz wprowadzić charakterystyczne grafiki dla nagłówków i stopek wprowadzonych organizacji, przechodząc do edycji.",
		description2: "Przechodząc do edycji możesz wprowadzić charakterystyczne grafiki lub poprawić dane adresowe dla nagłówków i stopek wprowadzonych wydziałów.",
		list: {
			name: "Nazwa organizacji",
			noElements: 'Brak organizacji spełniających określone kryteria wyszukiwania.',
			searchLabel: "Wyszukaj organizację po jej nazwie",
			deleteTooltip:  "Niektórych organizacji nie można usunąć, ponieważ mają powiązania w systemie.",
			edit: "Edytuj nazwę organizacji",
		},
		buttons: {
			loadFile: "Załaduj plik z listą organizacji (.xlsx)",
			addDep: "Dodaj organizację",
		},
		modalDelete: {
			title: "Usuń organizację",
			desc2: "Organizacja nie ma żadnych powiązań w systemie.",
		},
		modalUpload: {
			title: "Załaduj plik z listą organizacji (.xlsx)",
			desc: {
				part1: 'Załaduj plik z listą organizacji w formacie .xlsx. Plik powinien zawierać 3 kolumny, o takich samych nazwach jak w tabeli na stronie:',
				list: {
					part1: 'Nazwa organizacji',
				},
				part3: 'Obowiązkowo uzupełnij pierwszą kolumnę „Nazwa organizacji”, pozostałe są opcjonalne. Charakterystyczne grafiki dla nagłówków i stopek organizacji (o ile istnieją) dodasz po załadowaniu pliku do systemu, przechodząc do edycji nagłówka i stopki.',
			},
			warning: {
				part2: "jeśli są już wprowadzone dane organizacji, to nie zostaną one nadpisane po załadowaniu tego pliku. Można je usunąć / edytować bezpośrednio w serwisie. ",
			},
		},
		modalAdd: {
			title: "Dodaj organizację",
			desc: "Po dodaniu organizacji będzie możliwe dodanie grafiki do nagłówka i stopki (jeśli istnieje).",
			label: "Nazwa organizacji *",
			placeholder: "Wpisz nazwę organizacji",
			warning: {
				part2: "jeśli zmieniasz nazwę organizacji pamiętaj, aby ją uwzględnić również w tekście nagłówka i stopki.",
			},
			addButton: "Dodaj organizację",
		},
		modalEdit: {
			title: "Edytuj nazwę organizacji",
			notUnique: "Organizacja o podanej nazwie już istnieje.",
		},
		modalEditHeaderFooter: {
			descHeaderPart2: "Treść nagłówka i grafika będą wygenerowane w pobranych pismach pochodzących z tej organizacji i szablonach utworzonych na jej podstawie.",
			descFooterPart2: "Treść stopki i grafika będą wygenerowane w pobranych pismach pochodzących z tej organizacji i szablonach utworzonych na jej podstawie.",
		},
	},
	users: {
		list: {
			department: "Organizacja",
		},
		modalAdd: {
			departmentInfo: "Pole jest obowiązkowe do wypełnienia dla wszystkich oprócz administratorów",
			addNewDepartmentInfo: "Dodaj kolejną organizację",
			departmentLabel: "Organizacja",
			departmentPlaceholder: "Wybierz organizację",
		},
		modalLoad: {
			department: "Organizacja",
			desc: "Wszystkie kolumny są obowiązkowe do wypełnienia. Wyjątek stanowią administratorzy, dla których nie trzeba podawać organizacji.",
		},
	},
	letter: {
		metadata: {
			department: "Organizacja",
		},
		info: {
			department: "Organizacja: ",
		},
	},
	letters: {
		dept: 'Organizacja',
		searchByDepartment: 'Organizacja',
		defaultDeptTooltip: 'Domyślnie wyświetlane są pisma pochodzące z organizacji, do której należysz.',
	},
	addLetter: {
		department: "Organizacja *",
	},
	sortOptions: {
		department: 'Organizacja A - Z',
		departmentReverse: 'Organizacja Z - A',
		departmentName: 'Nazwa organizacji A - Z',
		departmentNameReverse: 'Nazwa organizacji Z - A',
	},
	footer: {
		links: {
			listDeps: "Organizacje",
		},
	},
	simpleTextAdvices: {
		admin: {
			tablePublish: {
				label: {
					department: "ORGANIZACJA",
				},
			},
			tableSubmited: {
				label: {
					department: "ORGANIZACJA",
				},
			},
		},
	},
};

export default pl;
